import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Filter from './UI.CompareList.Filter';
import { Urls } from 'kts-platform-frame/entry/constant';
import {  history } from 'kts-platform-frame/routes';
import {Card, Row, Col, Button, Icon, Table, Modal, Form, Input, Spin, message} from 'antd';
import { Field } from 'kts-scaffold-framework/utils/doc';

const { formatTime, formatDate } = Field;

const css = require('./index.scss');
const FormItem = Form.Item;
/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))
export default class  extends UIBasic<IProps, ModulesState> {
    state = {
        expand: true,
        addModalDisplay: false,
    };
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount () {
        this.getData();
    }
    render() {
        const {loadingUrls} = this.props;
        const extraContent = (
            <Row>
                <Col span={24} className="text-right">
                    <Button icon="sync" onClick={this.refreshInvoice}>刷新</Button>
                    <Button className="ml-10" type="primary" onClick={()=>{this.toggle(true);}}>新增批次</Button>
                    <Button className="ml-10" onClick={()=>{this.toggleFilter();}} >
                        筛选 <Icon type={this.state.expand ? "up" : "down"} />
                    </Button>
                </Col>
            </Row>
        );
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 }
        };
        const columns = [
            {
                title: "批次名称",
                dataIndex: "note",
                width: 300,
                render: (text) => {
                    return (
                        <span>{text}</span>
                    );
                }
            },
            {
                title: "创建时间",
                dataIndex: 'createTime',
                render: (text, record) => {
                    return (
                        <span>{formatDate(record.createTime)}</span>
                    );
                }
            },
            {
                title: "操作",
                dataIndex: "operate",
                className: "text-right",
                render: (text, record) => {
                    return <div>
                        <span className="click-item" onClick={() =>{this.handleDelete(record);}}>删除 | </span>
                        <span className="click-item" onClick={()=>{this.view(record);}}>发票对比</span>
                    </div>;
                }
            }
        ];
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={css.right}>
                <Card title="发票对比" extra={extraContent} >
                <div style={{ display: this.state.expand ? "block" : "none" }}>
                    <Filter />
                </div>
                <Spin spinning={loadingUrls.size > 0}>
                    <Table
                        columns={columns}
                        dataSource={this.modulesState.listData}
                        rowKey='compareBachId'
                        pagination={{
                            onChange: ModulesAction.handlelistPageChange, 
                            defaultPageSize: 10, 
                            total: this.modulesState.listPageTotal,
                            current: this.modulesState.listPageNumber 
                        }}
                    >

                    </Table>
                </Spin>
                </Card>
                <Modal
                    title="新增批次"
                    visible={this.state.addModalDisplay}
                    footer={null}
                    onCancel={()=>{this.toggle(false);}}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <FormItem
                            label="批次名称"
                            {...formItemLayout} 
                            style={{margin: '20px 20px 40px'}}
                        >
                            {getFieldDecorator('note', {
                                rules: [
                                    {
                                        required: true,
                                        message: "请填写信息"
                                    }
                                ]
                            })(
                                <Input style={{marginLeft: 6}}/>
                            )}
                        </FormItem>
                        <div style={{ 'textAlign': 'right' }}>
                            <Button type="default" onClick={()=>{this.toggle(false);}}>取消</Button>
                            <Button type="primary"  className="ml-10" htmlType="submit">提交</Button>
                        </div>
                    </Form>
                </Modal>
            </div>
        );
    }
    private toggle =(flag)=>{
        this.setState({
            addModalDisplay: flag,
        });
    }
    private refreshInvoice = () => {
        this.getData();
    }
    private addCompare = () => {
        console.log(455);   
    }
    private handleDelete = (record) => {
        Modal.confirm({
            content: '确认删除本批次？',
            onOk: ()=>{
                ModulesAction.delCompare({compareBachId: record.compareBachId}).then(()=>{
                    this.getData();
                });
                
            }
        });
       
        
    }
    private view = (record) =>{
        history.push(`/workbench/invoiceCompare/compareDetail/${record.compareBachId}`);
    }
    private handleCancel = () => {
        console.log(212121);
    }
    private handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async(err, values) => {
            if (!err) {
                console.log(values);
                await ModulesAction.addCompare(values);
                this.getData();
                this.toggle(false);
            }
        });
         
    }
    private toggleFilter = () =>{
        console.log(1212121);
        this.setState({
            expand: !this.state.expand
        });
    }
    private getData =()=>{
        const { user } = MyStore.instance.getState();
        const userId = user.userInfo.cUserId;
        const companyId = user.userInfo.companyId;
        ModulesAction.updateCompareList({
            pageNum: this.modulesState.listPageNumber,
            pageSize: 10,
            userId,
            companyId
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceCompare/UI.CompareList.tsx